// Imports
import ___CSS_LOADER_API_SOURCEMAP_IMPORT___ from "../../../../node_modules/css-loader/dist/runtime/sourceMaps.js";
import ___CSS_LOADER_API_IMPORT___ from "../../../../node_modules/css-loader/dist/runtime/api.js";
var ___CSS_LOADER_EXPORT___ = ___CSS_LOADER_API_IMPORT___(___CSS_LOADER_API_SOURCEMAP_IMPORT___);
// Module
___CSS_LOADER_EXPORT___.push([module.id, `.zoom-controls-bottom {
  position: fixed;
  bottom: 5px;
  right: 15px;
  z-index: 10000;
  background: #fff;
  padding: 2px 4px;
  display: none;
}
.zoom-controls-bottom .zoom-controls-container {
  display: flex;
  align-items: center;
  gap: 5px;
}
.zoom-controls-bottom .zoom-controls-container .zoom-btn {
  width: 22px;
  height: 22px;
  border: 1px solid #ccc;
  background: #fff;
  color: #333;
  cursor: pointer;
  display: flex;
  align-items: center;
  justify-content: center;
  font-size: 11px;
  transition: background 0.15s ease;
}
.zoom-controls-bottom .zoom-controls-container .zoom-btn:hover:not(:disabled) {
  background: #f5f5f5;
}
.zoom-controls-bottom .zoom-controls-container .zoom-btn:disabled {
  opacity: 0.3;
  cursor: not-allowed;
}
.zoom-controls-bottom .zoom-controls-container .zoom-btn i {
  font-size: 9px;
}
.zoom-controls-bottom .zoom-controls-container .fit-screen i {
  font-size: 10px;
}
.zoom-controls-bottom .zoom-controls-container .zoom-slider {
  appearance: none;
  width: 90px;
  height: 1px;
  background: #ccc;
  outline: none;
  cursor: pointer;
}
.zoom-controls-bottom .zoom-controls-container .zoom-slider::-webkit-slider-thumb {
  appearance: none;
  width: 10px;
  height: 10px;
  background: #666;
  cursor: pointer;
}
.zoom-controls-bottom .zoom-controls-container .zoom-slider::-moz-range-thumb {
  width: 10px;
  height: 10px;
  background: #666;
  cursor: pointer;
  border: none;
}
.zoom-controls-bottom .zoom-controls-container .zoom-percentage {
  font-size: 11px;
  color: #333;
  min-width: 32px;
  text-align: left;
}

@media (max-width: 768px) {
  .zoom-controls-bottom {
    bottom: 5px;
    right: 10px;
  }
  .zoom-controls-bottom .zoom-controls-container {
    gap: 4px;
  }
  .zoom-controls-bottom .zoom-controls-container .zoom-btn {
    width: 20px;
    height: 20px;
  }
  .zoom-controls-bottom .zoom-controls-container .zoom-btn i {
    font-size: 8px;
  }
  .zoom-controls-bottom .zoom-controls-container .zoom-slider {
    width: 70px;
  }
  .zoom-controls-bottom .zoom-controls-container .zoom-percentage {
    font-size: 10px;
    min-width: 28px;
  }
}`, "",{"version":3,"sources":["webpack://./src/containers/power-bi-portal/components/ZoomControls.scss"],"names":[],"mappings":"AAAA;EACE,eAAA;EACA,WAAA;EACA,WAAA;EACA,cAAA;EACA,gBAAA;EACA,gBAAA;EACA,aAAA;AACF;AACE;EACE,aAAA;EACA,mBAAA;EACA,QAAA;AACJ;AACI;EACE,WAAA;EACA,YAAA;EACA,sBAAA;EACA,gBAAA;EACA,WAAA;EACA,eAAA;EACA,aAAA;EACA,mBAAA;EACA,uBAAA;EACA,eAAA;EACA,iCAAA;AACN;AACM;EACE,mBAAA;AACR;AAEM;EACE,YAAA;EACA,mBAAA;AAAR;AAGM;EACE,cAAA;AADR;AAMM;EACE,eAAA;AAJR;AAQI;EAEE,gBAAA;EACA,WAAA;EACA,WAAA;EACA,gBAAA;EACA,aAAA;EACA,eAAA;AANN;AAQM;EAEE,gBAAA;EACA,WAAA;EACA,YAAA;EACA,gBAAA;EACA,eAAA;AANR;AASM;EACE,WAAA;EACA,YAAA;EACA,gBAAA;EACA,eAAA;EACA,YAAA;AAPR;AAWI;EACE,eAAA;EACA,WAAA;EACA,eAAA;EACA,gBAAA;AATN;;AAeA;EACE;IACE,WAAA;IACA,WAAA;EAZF;EAcE;IACE,QAAA;EAZJ;EAcI;IACE,WAAA;IACA,YAAA;EAZN;EAcM;IACE,cAAA;EAZR;EAgBI;IACE,WAAA;EAdN;EAiBI;IACE,eAAA;IACA,eAAA;EAfN;AACF","sourcesContent":[".zoom-controls-bottom {\r\n  position: fixed;\r\n  bottom: 5px; // Position on the footer\r\n  right: 15px;\r\n  z-index: 10000; // Higher than footer's z-index: 3\r\n  background: #fff; // White background to be visible on footer\r\n  padding: 2px 4px;\r\n  display:none;\r\n\r\n  .zoom-controls-container {\r\n    display: flex;\r\n    align-items: center;\r\n    gap: 5px;\r\n\r\n    .zoom-btn {\r\n      width: 22px;\r\n      height: 22px;\r\n      border: 1px solid #ccc;\r\n      background: #fff;\r\n      color: #333;\r\n      cursor: pointer;\r\n      display: flex;\r\n      align-items: center;\r\n      justify-content: center;\r\n      font-size: 11px;\r\n      transition: background 0.15s ease;\r\n\r\n      &:hover:not(:disabled) {\r\n        background: #f5f5f5;\r\n      }\r\n\r\n      &:disabled {\r\n        opacity: 0.3;\r\n        cursor: not-allowed;\r\n      }\r\n\r\n      i {\r\n        font-size: 9px;\r\n      }\r\n    }\r\n\r\n    .fit-screen {\r\n      i {\r\n        font-size: 10px;\r\n      }\r\n    }\r\n\r\n    .zoom-slider {\r\n      -webkit-appearance: none;\r\n      appearance: none;\r\n      width: 90px;\r\n      height: 1px;\r\n      background: #ccc;\r\n      outline: none;\r\n      cursor: pointer;\r\n\r\n      &::-webkit-slider-thumb {\r\n        -webkit-appearance: none;\r\n        appearance: none;\r\n        width: 10px;\r\n        height: 10px;\r\n        background: #666;\r\n        cursor: pointer;\r\n      }\r\n\r\n      &::-moz-range-thumb {\r\n        width: 10px;\r\n        height: 10px;\r\n        background: #666;\r\n        cursor: pointer;\r\n        border: none;\r\n      }\r\n    }\r\n\r\n    .zoom-percentage {\r\n      font-size: 11px;\r\n      color: #333;\r\n      min-width: 32px;\r\n      text-align: left;\r\n    }\r\n  }\r\n}\r\n\r\n// Mobile responsive\r\n@media (max-width: 768px) {\r\n  .zoom-controls-bottom {\r\n    bottom: 5px;\r\n    right: 10px;\r\n\r\n    .zoom-controls-container {\r\n      gap: 4px;\r\n\r\n      .zoom-btn {\r\n        width: 20px;\r\n        height: 20px;\r\n\r\n        i {\r\n          font-size: 8px;\r\n        }\r\n      }\r\n\r\n      .zoom-slider {\r\n        width: 70px;\r\n      }\r\n\r\n      .zoom-percentage {\r\n        font-size: 10px;\r\n        min-width: 28px;\r\n      }\r\n    }\r\n  }\r\n}\r\n"],"sourceRoot":""}]);
// Exports
___CSS_LOADER_EXPORT___.locals = {};
export default ___CSS_LOADER_EXPORT___;
